import { render, staticRenderFns } from "./merchant-register-input.component.vue?vue&type=template&id=5153cd01"
import script from "./merchant-register-input.component.vue?vue&type=script&lang=ts"
export * from "./merchant-register-input.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports